import React from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { Button, MenuDivider, MenuItem, MenuList } from "@chakra-ui/react";
import useStore, { ClasswizeState } from "@/stores/index";
import { useUserSessionStore } from "@/stores/v2/userSessionStore";
import { isChatFeatureEnabled } from "@/js/utils/chatUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";

export function CurrentUserPopup(): JSX.Element {
	const navigate = useNavigate();

	const userSessionStore = useUserSessionStore();

	const isChatEnabled = isChatFeatureEnabled();
	const inClassroom = !!useMatch("/classroom/:classId");
	const hasChatError = useStore((state: ClasswizeState) => state.chat.chatError);

	function handleLogout() {
		navigate("/login");
	}

	const toggleDisplayNameModal = useStore((state: ClasswizeState) => state.chat.toggleDisplayNameModal);

	function openChatSettings() {
		toggleDisplayNameModal(true, true);
	}

	return (
		<MenuList px={3}>
			<MenuItem color="neutrals.800" cursor="default" background="transparent">
				{userSessionStore.getActiveUser()}
			</MenuItem>
			{inClassroom && isChatEnabled && !hasChatError && (
				<MenuItem onClick={openChatSettings} color="#0075db" fontWeight="medium" background="transparent">
					<ChakraFAIcon icon="fa-cog" variant="solid" mr={3} />
					Chat Settings
				</MenuItem>
			)}

			<MenuDivider />
			<MenuItem as={Button} onClick={handleLogout} backgroundColor="brand.400" color="neutrals.0">
				Sign out
			</MenuItem>
		</MenuList>
	);
}
